/* IGSHOP CUSTOM — Collection page helpers.
   Two small behaviours only; everything else is plain links and native
   <details>, so the page still filters and sorts with JS disabled. */

(function () {
  'use strict';

  // Submit the sort form as soon as a new option is chosen.
  document.querySelectorAll('[data-bbc-sort] select').forEach(function (select) {
    select.addEventListener('change', function () {
      select.form.submit();
    });
  });

  // Only one filter dropdown open at a time, and close on outside click.
  var drops = Array.prototype.slice.call(document.querySelectorAll('.bbc-drop'));

  drops.forEach(function (drop) {
    drop.addEventListener('toggle', function () {
      if (!drop.open) return;
      drops.forEach(function (other) {
        if (other !== drop) other.open = false;
      });
    });
  });

  document.addEventListener('click', function (event) {
    drops.forEach(function (drop) {
      if (drop.open && !drop.contains(event.target)) drop.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    drops.forEach(function (drop) {
      drop.open = false;
    });
  });
})();
